import { Component, OnInit, Inject, inject, DestroyRef } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { EVC_MODAL_DATA, EVC_MODAL_REF, type ModalRef } from "../../_shared/services/modal/evc-modal.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
    selector: 'app-summary-comment-dialog',
    templateUrl: 'summary-comment-dialog.component.html',
    styleUrls: ['./summary-comment-dialog.component.scss'],
    standalone: false
})
export class SummaryDialogComponent implements OnInit {
  readonly commentMaxLength = 1000;
  private readonly destroyRef = inject(DestroyRef);
  isEmpty: boolean = true;
  commentControl: FormControl<string>;
  
  locationName: string = '';
  comment: string = '';
  hasInitialComment: boolean = false;

  constructor(
    @Inject(EVC_MODAL_REF) private modalRef: ModalRef<string>,
    @Inject(EVC_MODAL_DATA) modalData: { locationName: string; comment: string; }
  ) { 
    this.locationName = modalData.locationName;
    this.comment = modalData.comment;
    this.hasInitialComment = !!modalData.comment;
  }
  
  ngOnInit() {
    this.commentControl = new FormControl(this.comment, [
      Validators.maxLength(this.commentMaxLength),
    ]);

    this.commentControl.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((comment) => {
        this.isEmpty = comment !== null && comment.trim().length === 0;
      });
  }

  closeDialog(): void {
    this.modalRef.close();
  }

  onSave() {
    this.modalRef.close(this.commentControl.value);
  }
}